<template>
  <v-list-tile>
    <v-list-tile-content>
      <v-list-tile-title> {{ survey.SurveyDateTimeRaw }} </v-list-tile-title>
      <v-list-tile-sub-title>
        <v-layout row wrap>
          <v-flex xs12 sm8>
            <v-layout row wrap>
              <v-flex xs12>
                <span class='text--primary'>Execution Id: </span>{{ survey.ExecutionId }}
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 sm4>
            <v-btn small round> View</v-btn>
          </v-flex>
        </v-layout>
      </v-list-tile-sub-title>
    </v-list-tile-content>
  </v-list-tile>
</template>

<script>
  export default {
    props: {
      value: {
        type: Object,
        required: true,
      },
    },
    computed: {
      survey() {
        return this.value
      },
    },
  }
</script>